export enum ButtonShape {
  Circle = 'circle',
  Round = 'round',
  Default = 'default'
}
